"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableView = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _DownloadButtons = require("../../DownloadButtons");

var _Utils = _interopRequireDefault(require("../../../utils/Utils"));

var _config = require("../../../config");

var _antd = require("antd");

var _ChangeTableViewButton = require("../../ChangeTableViewButton");

var PropTypes = _interopRequireWildcard(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _stringHash = _interopRequireDefault(require("string-hash"));

var _TranslationContext = require("../../TranslateAware/TranslationContext");

var _TableItemsCountWText = require("./TableItemsCountWText");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SimpleColumn = function SimpleColumn(_ref) {
  var column = _ref.column,
      translate = _ref.translate;
  var translationContext = (0, _react.useContext)(_TranslationContext.TranslationContext);

  if (column.title === undefined) {
    return translate(column.dataIndex, undefined, translationContext);
  } else if (typeof column.title === "string") {
    // if column has children, then translate their titles
    if (column.children) {
      column.children.forEach(function (child) {
        child.title = translate(child.title, undefined, translationContext);
      });
    }

    return translate(column.title, undefined, translationContext);
  } else {
    return column.title;
  }
};

var defaultPagination = _config.Config.get("settings", "defaultPagination");

var TableView =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(TableView, _React$PureComponent);

  function TableView(props) {
    var _this;

    _classCallCheck(this, TableView);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TableView).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "applyMultiSort", function (columns) {
      var col = [];

      if (_this.state.additionalSort) {
        Object.values(columns).forEach(function (column, i) {
          var partiallyUpdatedColumn = _this.applyMultiSortOnColumnElement(column, -1); // if column has children (group)


          if (column.children) {
            var childrenColumns = [];
            Object.values(column.children).forEach(function (childColumn, j) {
              var partiallyUpdatedChildColumn = _this.applyMultiSortOnColumnElement(childColumn, j);

              childrenColumns.push(partiallyUpdatedChildColumn);
            });
            partiallyUpdatedColumn.children = childrenColumns;
          }

          col.push(partiallyUpdatedColumn);
        });
      }

      col = col.length === 0 ? columns : col;
      return col;
    });

    _defineProperty(_assertThisInitialized(_this), "applyMultiSortOnColumnElement", function (p, i) {
      var col = undefined;

      var currentField = _lodash["default"].find(_this.state.additionalSort, function (o) {
        return o.col === p.dataIndex;
      });

      var filterDropdown = _react["default"].createElement(_react["default"].Fragment, null);

      var currentFieldPriority = currentField ? currentField.priority : null;

      var filterIcon = _react["default"].createElement("span", {
        style: {
          display: "none"
        }
      });

      if (_this.state.additionalSort.length > 1) {
        filterIcon = _react["default"].createElement("span", null, currentFieldPriority);
      }

      var currentSortFields = _lodash["default"].map(_this.state.additionalSort, "col");

      var currentSortOrder = _lodash["default"].map(_this.state.additionalSort, "ord");

      i = currentSortFields.indexOf(p.dataIndex);
      var sorterClass = p.sorter ? "sortable " : "";
      var compactClass = p.compact ? "compact " : "";
      var compactSize = compactClass ? "compact-" + p.compactSize + " " : "";
      var sortOrder = p.sortOrder ? p.sortOrder : false;
      var isNowrap = typeof p.title !== "string"; // only for string title

      if (i > -1 && _this.state.sorter && _this.state.sorter.field) {
        var order = currentSortOrder[i];
        col = _objectSpread({}, p, {
          filterIcon: filterIcon,
          filterDropdown: filterDropdown,
          sortOrder: sortOrder,
          onHeaderCell: _this.onHeaderCell,
          className: sorterClass + compactClass + compactSize + (isNowrap == true ? " nowrap" : "") + "  selected " + (order === "ascend" ? "selected-up" : "selected-down")
        });
      } else {
        col = _objectSpread({}, p, {
          filterIcon: filterIcon,
          filterDropdown: filterDropdown,
          sortOrder: sortOrder,
          onHeaderCell: _this.onHeaderCell,
          className: compactClass + compactSize + (isNowrap == true ? "nowrap " : "") + sorterClass
        });
      }

      return col;
    });

    _defineProperty(_assertThisInitialized(_this), "onHeaderCell", function (column) {
      return {
        onClick: function onClick(e) {
          // TODO: Refactor this implementation.
          // Fix. Do not handle event when click on DatePicker input or popup calender or other outside elements;
          var tableDom = _reactDom["default"].findDOMNode(_this.tableRef.current);

          if (e.target.tagName === "INPUT" || !tableDom.contains(e.target) || !column.sorter || _this.props.multiSortField.selected) return;
          setTimeout(function () {
            if (!this.state.tableColumnWasChanged) {
              var currentField = _lodash["default"].find(this.state.additionalSort, function (o) {
                return o.col === column.dataIndex;
              });

              if (currentField) {
                var currentSortFields = _lodash["default"].map(this.state.additionalSort, "col");

                var i = currentSortFields.indexOf(column.dataIndex);
                var currentFieldOrder = currentField.ord;

                if (currentFieldOrder === "ascend") {
                  this.setState({
                    sorter: {
                      field: column.dataIndex,
                      order: "descend"
                    }
                  });
                } else if (currentFieldOrder === "descend") {
                  var currentFieldPriority = currentField.priority;
                  this.state.additionalSort.splice(i, 1);

                  _lodash["default"].each(this.state.additionalSort, function (p) {
                    if (p.priority > currentFieldPriority) {
                      p.priority--;
                    }
                  });

                  var objectWithLowestPriority = _lodash["default"].maxBy(this.state.additionalSort, "priority");

                  if (objectWithLowestPriority) {
                    this.setState({
                      sorter: {
                        field: objectWithLowestPriority.col,
                        order: objectWithLowestPriority.ord
                      }
                    });
                  } else {
                    this.setState({
                      sorter: {}
                    });
                  }
                }

                _lodash["default"].each(this.state.columns, function (p) {
                  if (p.dataIndex === column.dataIndex) {
                    p.sortOrder = false;
                  }
                });
              } else {
                this.setState({
                  sorter: {
                    field: column.dataIndex,
                    order: "ascend"
                  }
                });
              }

              this.updateFileDownloadSortingParams();
              var sorter = Object.assign({}, this.state.sorter, {
                additionalSortFilter: JSON.stringify(this.state.additionalSort)
              }); // this.state.sorter.additionalSortFilter = {additionalSortFilter: JSON.stringify(this.state.additionalSort)};

              this.setState({
                sorter: sorter,
                tableColumnWasChanged: false
              });
            }
          }.bind(_assertThisInitialized(_this)), 100);
        }
      };
    });

    _defineProperty(_assertThisInitialized(_this), "translateColumn", function () {
      var _this$props = _this.props,
          translate = _this$props.translate,
          columns = _this$props.columns;
      var newColumns = [];
      columns.forEach(function (column) {
        newColumns.push(_objectSpread({}, column, {
          title: column.renderTitle ? column.renderTitle(_this.props) : _react["default"].createElement(SimpleColumn, {
            column: column,
            translate: translate
          }),
          render: column.render
        }));
      });
      return newColumns;
    });

    _defineProperty(_assertThisInitialized(_this), "applyColumnsTranslation", function (newColumns) {
      _this.setState({
        columns: _toConsumableArray(newColumns)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "filter", function (params) {
      if (params.reset) return;

      _this.setState({
        pagination: {
          page: 1,
          pageSize: _this.state.pagination.pageSize
        }
      }); // Merge filters with table filterParams


      var filterParams = Object.assign({}, _this.props.filterParams, params);

      _this.serverRequest({
        page: 1,
        pageSize: _this.state.pagination.pageSize
      }, _objectSpread({}, _this.state.sorter), filterParams);
    });

    _defineProperty(_assertThisInitialized(_this), "updateFilter", function () {
      var pagination = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.pagination;
      var sorting = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.state.sorter;
      var onMount = arguments.length > 2 ? arguments[2] : undefined;
      var _this$props2 = _this.props,
          applyDataFilter = _this$props2.applyDataFilter,
          satDataFilter = _this$props2.satDataFilter,
          dataType = _this$props2.dataType,
          tableType = _this$props2.tableType,
          reportType = _this$props2.reportType,
          withoutPaging = _this$props2.withoutPaging,
          chosenMenuItem = _this$props2.chosenMenuItem,
          locale = _this$props2.locale;
      var additionalSortFilter;

      if (!_this.state.additionalSortFilter) {
        additionalSortFilter = JSON.stringify(_this.state.additionalSort);
      }

      _this.updateFileDownloadSortingParams();

      var tablePagination = withoutPaging ? {} : {
        pageNum: pagination.page,
        pageSize: pagination.pageSize
      };
      var dashboardParams = tableType === "dashboard" ? {
        salesReportType: chosenMenuItem ? chosenMenuItem : ""
      } : {};

      var requestParams = _objectSpread({}, tablePagination, {}, sorting, {
        //...filtering,
        additionalSortFilter: additionalSortFilter
      }, dashboardParams, {
        reportType: reportType
      });

      requestParams["locale"] = locale;

      if (onMount) {
        satDataFilter(dataType, requestParams);
      } else {
        applyDataFilter(dataType, requestParams);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "serverRequest", function () {
      var pagination = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.pagination;
      var sorting = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.state.sorter;
      var needsUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var params = arguments.length > 3 ? arguments[3] : undefined;
      var _this$props3 = _this.props,
          filterParams = _this$props3.filterParams,
          dispatch = _this$props3.dispatch,
          url = _this$props3.url,
          tableType = _this$props3.tableType,
          dataType = _this$props3.dataType,
          reportType = _this$props3.reportType,
          withoutPaging = _this$props3.withoutPaging,
          chosenMenuItem = _this$props3.chosenMenuItem,
          resetData = _this$props3.resetData,
          dataLoadAction = _this$props3.dataLoadAction,
          fetchViewData = _this$props3.fetchViewData,
          locale = _this$props3.locale,
          filterType = _this$props3.filterType,
          applyDataFilter = _this$props3.applyDataFilter; // let filtering = (params) ? params : filterParams;

      var additionalSortFilter;

      if (!_this.state.additionalSortFilter) {
        additionalSortFilter = JSON.stringify(_this.state.additionalSort);
      }

      _this.updateFileDownloadSortingParams();

      var tablePagination = withoutPaging ? {} : {
        pageNum: pagination.page,
        pageSize: pagination.pageSize
      };
      var dashboardParams = tableType === "dashboard" ? {
        salesReportType: chosenMenuItem ? chosenMenuItem : ""
      } : {};

      var requestParams = _objectSpread({}, tablePagination, {}, sorting, {
        //...filtering,
        additionalSortFilter: additionalSortFilter
      }, dashboardParams, {
        reportType: reportType
      });

      requestParams["locale"] = locale;
      applyDataFilter(dataType, requestParams, needsUpdate); // fetchViewData(requestParams);
      // if(dataLoadAction) {
      //     dispatch(dataLoadAction(tableType, requestParams, resetData ? resetData : false, this));
      // } else {
      //     dispatch(getTableData({
      //         params: requestParams,
      //         resetData: resetData ? resetData : false,
      //     }, url, tableType, this));
      // }
    });

    _defineProperty(_assertThisInitialized(_this), "handleTableChange", function (pagination, filters, sorter) {
      _this.setState({
        tableColumnWasChanged: true
      });

      var current = pagination.current,
          pageSize = pagination.pageSize;
      var field = sorter.field,
          order = sorter.order;
      var isPageSizeChanged = _this.state.pagination.pageSize !== pageSize;

      if (isPageSizeChanged) {
        var page = parseInt(_this.state.pagination.pageSize * (_this.state.pagination.page - 1) / pageSize, 10) + 1;

        _this.setState({
          pagination: {
            page: page,
            pageSize: pageSize
          }
        });
      }

      var currentField = _lodash["default"].find(_this.state.additionalSort, function (o) {
        return o.col === field;
      });

      if (currentField) {
        if (sorter.column.dataIndex === field) {
          var className = sorter.column.className;

          if (order === "descend" && _lodash["default"].includes(className, "selected-down") || order === "ascend" && _lodash["default"].includes(className, "selected-up")) {
            var currentSortFields = _lodash["default"].map(_this.state.additionalSort, "col");

            var i = currentSortFields.indexOf(field);
            field = undefined;
            order = undefined;
            var currentFieldPriority = currentField.priority;

            _this.state.additionalSort.splice(i, 1);

            _lodash["default"].each(_this.state.additionalSort, function (p) {
              if (p.priority > currentFieldPriority) {
                p.priority--;
              }
            });

            var objectWithLowestPriority = _lodash["default"].maxBy(_this.state.additionalSort, "priority");

            if (objectWithLowestPriority) {
              _this.setState({
                sorter: {
                  field: objectWithLowestPriority.col,
                  order: objectWithLowestPriority.ord
                }
              });

              field = objectWithLowestPriority.col;
              order = objectWithLowestPriority.ord;
            } else {
              _this.setState({
                sorter: {}
              });

              field = undefined;
              order = undefined;

              _lodash["default"].each(_this.state.columns, function (p) {
                if (currentField.col === p.dataIndex) {
                  sorter.column.sortOrder = false;
                }
              });
            }
          }
        }
      }

      var isSorting = field !== undefined && !(_this.state.sorter.field === field && _this.state.sorter.order === order);

      var arrayWithAnotherSortOrder = _this.state.columns.map(function (item) {
        if (item.sortOrder) {
          delete item.sortOrder;
        }

        if (field === item.dataIndex) {
          item.sortOrder = order;
        }

        return item;
      });

      _this.updateFileDownloadSortingParams();

      _this.setState({
        pagination: {
          page: isPageSizeChanged || isSorting ? parseInt(_this.state.pagination.pageSize * (_this.state.pagination.page - 1) / pageSize, 10) + 1 : current,
          pageSize: pageSize
        },
        sorter: {
          field: field,
          order: order,
          additionalSortFilter: JSON.stringify(_this.state.additionalSort)
        },
        columns: _toConsumableArray(arrayWithAnotherSortOrder)
      });

      setTimeout(function () {
        this.setState({
          tableColumnWasChanged: false
        });
      }.bind(_assertThisInitialized(_this)), 500);
    });

    _defineProperty(_assertThisInitialized(_this), "updateFileDownloadSortingParams", function () {
      if (_this.getSortingParams) {
        _this.getSortingParams({
          additionalSortFilter: JSON.stringify(_this.state.additionalSort)
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "applyFailedSlaStyles", function (record, index) {
      if (!_this.props.applyStyleForFailedSlaRows) return "";

      if (record.sla3Level && record.cancelLevel) {
        var maxLevel = record.sla3Level > record.cancelLevel ? record.sla3Level : record.cancelLevel;

        if (maxLevel === 3) {
          return "sla-risk";
        }

        if (maxLevel > 3) {
          return "sla-danger";
        }

        return "";
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleSwitchLocalCurrency", function () {
      var localCurrencySwitches = _objectSpread({}, _this.state.localCurrencySwitches);

      localCurrencySwitches[_this.props.dataType] = !localCurrencySwitches[_this.props.dataType];

      _this.setState({
        localCurrencySwitches: localCurrencySwitches
      });

      if (_this.props.handleLocalCurrencySwitches) _this.props.handleLocalCurrencySwitches(_this.props.dataType);
    });

    _defineProperty(_assertThisInitialized(_this), "returnlocalCurrencySwitchValue", function () {
      if (_this.state.localCurrencySwitches && _this.state.localCurrencySwitches[_this.props.dataType]) {
        return _this.state.localCurrencySwitches[_this.props.dataType];
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "downloadFile", function (format, exportKey) {
      var _this$props4 = _this.props,
          filterValues = _this$props4.filterValues,
          chosenMenuItem = _this$props4.chosenMenuItem,
          tableType = _this$props4.tableType,
          dataSource = _this$props4.dataSource,
          startDownload = _this$props4.startDownload,
          locale = _this$props4.locale;
      var sorting = _this.state.sorting;
      var sortingParams = sorting ? sorting : {};

      var filterParamsDownload = _objectSpread({}, filterValues);

      if (_lodash["default"].has(filterValues, "chosenMenuItem")) {
        filterParamsDownload.salesReportType = filterValues.chosenMenuItem;
      } //Pending Returns Delivered Returns Only


      if (dataSource.queryParams && dataSource.queryParams.showDelivDateNotNull) {
        filterParamsDownload.showDelivDateNotNull = dataSource.queryParams.showDelivDateNotNull;
      }

      var url = dataSource.url;
      var urlDownload = "".concat(url, "/") + format;
      /*
       * sales dashboard params
       * */

      var chosenCurrency = filterParamsDownload.currency;

      if (chosenMenuItem) {
        filterParamsDownload.salesReportType = chosenMenuItem;
        filterParamsDownload.groupTimeBy = filterValues.groupTimeBy ? filterValues.groupTimeBy : dataSource.queryParams.groupTimeBy;

        if (filterParamsDownload.currency) {
          delete filterParamsDownload.currency;
        }
      }

      if (chosenCurrency) {
        filterParamsDownload.currency = chosenCurrency;
      } else if (tableType === "dashboard") {
        filterParamsDownload.currency = "EUR";
      }

      filterParamsDownload.locale = locale;
      startDownload(urlDownload, _objectSpread({}, filterParamsDownload, {}, sortingParams, {
        exportKey: exportKey
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "getSortingParams", function (params) {
      _this.setState({
        sorting: _objectSpread({}, params)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "applyChangedUserTableView", function (finalColumns) {
      var _this$props5 = _this.props,
          tabType = _this$props5.tabType,
          savedViews = _this$props5.savedViews;

      var savedViewsForCurrentTabType = _lodash["default"].find(savedViews, {
        tabType: tabType
      });

      var arr = [];

      if (savedViewsForCurrentTabType) {
        arr = savedViewsForCurrentTabType.filterData.length > 0 ? savedViewsForCurrentTabType.filterData.split(",") : [];
      }

      return finalColumns.filter(function (col) {
        return !_lodash["default"].includes(arr, col.dataIndex);
      });
    });

    _this.state = {
      pagination: _objectSpread({}, defaultPagination),
      columns: _toConsumableArray(_this.props.columns),
      sorter: _this.props.tableSort ? _this.props.tableSort : {
        field: "creationDate",
        order: "descend"
      },
      exportKey: _this.props.exportKey ? _this.props.exportKey : _this.props.dataType,
      defaultSort: _this.props.tableSort,
      additionalSort: _this.props.tableSort ? [{
        col: _this.props.tableSort.field,
        ord: _this.props.tableSort.order,
        priority: 1
      }] : [],
      tableColumnWasChanged: false,
      showSwitchLocalCurrency: false,
      localCurrencySwitches: _this.props.localCurrencySwitches
    };
    _this.tableRef = _react["default"].createRef();
    return _this;
  }

  _createClass(TableView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // const {provideFilter} = this.props;
      // if (this.props.filterParams) {
      //     this.serverRequest();
      // }
      // /*
      // * Providing this.filter method to the upper component
      // * */
      // if (provideFilter) provideFilter(this.filter);
      var _this$state = this.state,
          pagination = _this$state.pagination,
          sorter = _this$state.sorter;
      this.updateFilter(pagination, sorter, true);
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps, nextState, nextContext) {
      var _this$props6 = this.props,
          tableType = _this$props6.tableType,
          chosenMenuItem = _this$props6.chosenMenuItem;
      var fxViews = ["GrossSalesPerProductByCreationDate", "GrossSalesPerProduct", "NetSalesPerProductEuro", "SummariesGross", "SummariesAfterReturns", "priceValidationFull", "returnedOpen", "returnedCumulative"];
      this.state.showSwitchLocalCurrency = fxViews.includes(this.props.dataType, 0);

      if (tableType === "dashboard" && chosenMenuItem !== nextProps.chosenMenuItem) {
        nextState.additionalSort = nextProps.tableSort ? [{
          col: nextProps.tableSort.field,
          ord: nextProps.tableSort.order,
          priority: 1
        }] : [];
      }

      if (chosenMenuItem != nextProps.chosenMenuItem) {
        nextState.pagination['pageSize'] = 10;
        nextState.pagination['page'] = 1;
      }

      if (this.state.additionalSort.length === 1 && nextState.sorter && this.state.defaultSort && chosenMenuItem === nextProps.chosenMenuItem) {
        var defaultSortField = this.state.defaultSort.field;

        var defaultFieldInColumns = _lodash["default"].find(this.state.columns, function (o) {
          return o.dataIndex === defaultSortField;
        });

        if (this.state.additionalSort[0].col === defaultSortField && !defaultFieldInColumns) {
          nextState.additionalSort = [];
          nextState.sorter.additionalSortFilter = undefined;
        }
      }

      if (this.state.sorter !== nextState.sorter && nextState.sorter.field) {
        if (this.state.additionalSort.length === 0) {
          nextState.additionalSort.push({
            col: nextState.sorter.field,
            ord: nextState.sorter.order,
            priority: 1
          });
        } else {
          var index = _lodash["default"].map(this.state.additionalSort, "col").indexOf(nextState.sorter.field);

          if (index > -1) {
            var currentFieldPriority = nextState.additionalSort[index].priority;
            nextState.additionalSort.splice(index, 1);
            nextState.additionalSort.push({
              col: nextState.sorter.field,
              ord: nextState.sorter.order,
              priority: currentFieldPriority
            });
          } else {
            var prioritiesArray = _lodash["default"].map(nextState.additionalSort, "priority");

            var maxPriority = _lodash["default"].max(prioritiesArray);

            nextState.additionalSort.push({
              col: nextState.sorter.field,
              ord: nextState.sorter.order,
              priority: maxPriority + 1
            });
          }
        }

        nextState.sorter.additionalSortFilter = JSON.stringify(nextState.additionalSort);
      } else if (!nextState.sorter.field) {
        if (this.state.additionalSort.length === 1 && this.state.sorter && this.state.defaultSort && this.state.sorter.field === this.state.defaultSort.field) {// nextState.additionalSort = [];
          // nextState.additionalSortFilter = undefined;
        } else if (this.state.sorter && this.state.sorter.field && this.state.pagination === nextState.pagination) {
          var _index = _lodash["default"].map(nextState.additionalSort, "col").indexOf(this.state.sorter.field);

          if (_index > -1) {
            var _currentFieldPriority = nextState.additionalSort[_index].priority;
            nextState.additionalSort.splice(_index, 1);

            _lodash["default"].each(this.state.additionalSort, function (p) {
              if (p.priority > _currentFieldPriority) {
                p.priority--;
              }
            });
          }
        }

        var objectWithLowestPriority = _lodash["default"].maxBy(nextState.additionalSort, "priority");

        if (objectWithLowestPriority) {
          nextState.sorter = {
            field: objectWithLowestPriority.col,
            order: objectWithLowestPriority.ord
          };
        } // else {
        //     nextState.sorter = this.state.defaultSort ? this.state.defaultSort : {
        //         field: 'channel',
        //         order: 'ascend'
        //     };
        //     nextState.additionalSort.push({col: nextState.sorter.field, ord: nextState.sorter.order, priority: 1});
        // }


        nextState.sorter.additionalSortFilter = JSON.stringify(nextState.additionalSort);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$state2 = this.state,
          pagination = _this$state2.pagination,
          sorter = _this$state2.sorter;
      var _this$props7 = this.props,
          filterValues = _this$props7.filterValues,
          tableType = _this$props7.tableType,
          chosenMenuItem = _this$props7.chosenMenuItem,
          currency = _this$props7.currency,
          locale = _this$props7.locale;
      var _this$state$paginatio = this.state.pagination,
          page = _this$state$paginatio.page,
          pageSize = _this$state$paginatio.pageSize;
      var total = this.props.total; // if total record lower than visible page, go to last visible page

      if (total < (page - 1) * pageSize) {
        this.setState({
          pagination: Object.assign({}, pagination, {
            page: parseInt(total / pageSize, 10) + 1
          })
        });
      }

      var isSamePaginationParams = JSON.stringify(pagination) === JSON.stringify(prevState.pagination);
      var isSameSorterParams = JSON.stringify(sorter) === JSON.stringify(prevState.sorter); // let tableFilterParams = tableType ? filterParams[tableType] : filterParams;

      if (!isSamePaginationParams) {
        this.serverRequest(pagination, sorter, true);
      } else if (!isSameSorterParams) {
        this.serverRequest(pagination, sorter);
      } else if (prevProps.chosenMenuItem !== chosenMenuItem) {
        this.serverRequest(pagination, sorter);
      } else if (!_lodash["default"].isEqual(prevProps.locale, locale)) {
        this.serverRequest(pagination, sorter);
      } else if (prevProps.currency !== currency) {
        this.serverRequest(pagination, sorter);
      } // here we catch changes in redux core.store for filters in header of table
      // or connection status changes from offline to online
      else if (!_lodash["default"].isEqual(prevProps.filterValues, filterValues)) {
          //TODO Change logic of enabling new filter
          this.setState({
            pagination: {
              page: 1,
              pageSize: pageSize
            }
          }); // this.serverRequest(pagination, sorter, filterParams);
        }

      var translatedColumns = this.translateColumn();

      if (!_lodash["default"].isEqual(translatedColumns, prevState.columns)) {
        this.applyColumnsTranslation(translatedColumns);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props8 = this.props,
          dataType = _this$props8.dataType,
          data = _this$props8.data,
          translate = _this$props8.translate,
          rowKey = _this$props8.rowKey,
          withoutPaging = _this$props8.withoutPaging,
          components = _this$props8.components,
          scrollX = _this$props8.scrollX,
          scrollY = _this$props8.scrollY,
          rowSelection = _this$props8.rowSelection,
          paginationTop = _this$props8.paginationTop,
          tabType = _this$props8.tabType,
          showChangeTableViewButton = _this$props8.showChangeTableViewButton,
          headerFilters = _this$props8.headerFilters,
          loading = _this$props8.loading,
          showArticleReportCSVButton = _this$props8.showArticleReportCSVButton,
          hidePdfButton = _this$props8.hidePdfButton,
          isDataLoading = _this$props8.isDataLoading,
          showSKUReportButton = _this$props8.showSKUReportButton,
          isDateLoadingError = _this$props8.isDateLoadingError,
          itemsCountWText = _this$props8.itemsCountWText;
      var columns = this.state.columns;
      var emptyMessage = this.props.emptyMessage;
      var finalEmptyMessage = isDateLoadingError ? _react["default"].createElement("span", {
        style: {
          color: "red"
        }
      }, translate("data/loading/error")) : translate(emptyMessage);
      var total = data ? data.total : 0;
      var finalColumns = this.applyMultiSort(columns);
      var finalColumnsToDisplay = this.applyChangedUserTableView(finalColumns);

      if (this.returnlocalCurrencySwitchValue() === false || this.returnlocalCurrencySwitchValue() === null) {
        finalColumnsToDisplay = finalColumnsToDisplay.filter(function (item) {
          return !item.hidden;
        });
      }

      var exportKey = dataType;
      var exportKeyHash = (0, _stringHash["default"])(exportKey + Date.now().toString());
      var showHeader = showChangeTableViewButton || headerFilters;
      var headerFiltersCols = 0;
      if (showChangeTableViewButton) ++headerFiltersCols;
      if (showSKUReportButton) ++headerFiltersCols;
      if (headerFilters) ++headerFiltersCols;
      var headerFiltersColSize = Math.floor(24 / headerFiltersCols);

      if (data && data.__idsequence === undefined) {
        data.__idsequence = 0;
      } // TODO: refactor to use common data pattern with items property instead records


      var dataItems = [];

      if (_lodash["default"].has(data, "records")) {
        dataItems = data.records;
      }

      if (_lodash["default"].has(data, "items")) {
        dataItems = data.items;
      }

      return _react["default"].createElement(_react["default"].Fragment, null, !this.props.hideDownloadButtons && _react["default"].createElement(_DownloadButtons.DownloadButtons, {
        columns: finalColumns,
        showArticleReportCSVButton: showArticleReportCSVButton,
        exportKey: exportKey,
        onClick: this.downloadFile.bind(this),
        hidePdfButton: hidePdfButton,
        tabType: tabType,
        localCurrencySwitches: this.state.localCurrencySwitches,
        showSwitchRetDelivDate: this.props.showSwitchRetDelivDate,
        toggleSwitchRetDelivDate: this.props.toggleSwitchRetDelivDate,
        showSwitchLocalCurrency: this.state.showSwitchLocalCurrency,
        toggleSwitchLocalCurrency: this.toggleSwitchLocalCurrency
      }), showHeader && _react["default"].createElement(_antd.Row, {
        className: "mb-0"
      }, headerFilters && _react["default"].createElement(_antd.Col, {
        xs: 24,
        sm: showChangeTableViewButton ? 12 : 24,
        span: headerFiltersColSize,
        className: "mb-0"
      }, headerFilters), showChangeTableViewButton && _react["default"].createElement(_antd.Col, {
        xs: 24,
        sm: headerFilters ? 12 : 24,
        span: headerFiltersColSize,
        className: "text-right mb-0"
      }, showSKUReportButton && _react["default"].createElement(_antd.Tooltip, {
        placement: "topLeft",
        title: translate("view/downloadSKUReport")
      }, _react["default"].createElement(_antd.Button, {
        disabled: loading,
        className: "download-report-button download-button",
        type: "primary",
        icon: "download",
        style: {
          marginRight: "6px",
          marginTop: 1,
          fontSize: "12px"
        },
        onClick: function onClick() {
          _this2.downloadFile("sku-excel", exportKeyHash);
        }
      }, _react["default"].createElement("span", null, translate("view/downloadSKUReport")))), _react["default"].createElement(_ChangeTableViewButton.ChangeTableViewButton, {
        tabType: tabType,
        columns: columns
      }))), this.props.children, _react["default"].createElement(_antd.Table, {
        bordered: this.props.bordered,
        ref: this.tableRef,
        columns: finalColumnsToDisplay // loading={{
        //     spinning: true,
        //     indicator: spinIcon,
        // }}
        ,
        rowSelection: rowSelection !== undefined ? rowSelection(this.props) : undefined,
        locale: {
          emptyText: isDataLoading ? "" : translate("view/noResult")
        },
        dataSource: dataItems,
        rowKey: rowKey ? rowKey : function (record) {
          if (record.__uniqueid === undefined) {
            record.__uniqueid = ++data.__idsequence;
          }

          return record.__uniqueid;
        },
        footer: this.props.footer,
        scroll: {
          x: scrollX || false,
          y: scrollY || false
        },
        onChange: this.handleTableChange,
        components: components || {},
        rowClassName: function rowClassName(record, index) {
          return _this2.applyFailedSlaStyles(record, index);
        },
        pagination: !withoutPaging ? _objectSpread({}, this.state.pagination, {
          current: this.state.pagination.page,
          showLessItems: _Utils["default"].getOrientation() === "portrait",
          showSizeChanger: true,
          size: _Utils["default"].getWindowDimensions().height < 769 || _Utils["default"].getOrientation() === "portrait" ? "small" : "default",
          pageSizeOptions: ["10", "20", "30", "50"],
          position: paginationTop ? "top" : "bottom",
          style: paginationTop ? {
            marginRight: "230px",
            marginTop: "-48px"
          } : null,
          className: "custom-pagination",
          total: total,
          showTotal: function showTotal(total) {
            return _Utils["default"].getOrientation() !== "portrait" ? !_this2.props.itemsCountWText ? translate("table/paginationTotalText") + " " + total : _react["default"].createElement(_TableItemsCountWText.TableItemsCountWText, {
              translate: translate,
              total: total,
              itemsCountWText: _this2.props.itemsCountWText,
              data: _this2.props.data
            }) : "Total: " + total;
          }
        }) : false
      }));
    }
  }]);

  return TableView;
}(_react["default"].PureComponent);

exports.TableView = TableView;

_defineProperty(TableView, "propTypes", {
  loadData: PropTypes.bool,
  // [PROPS.DATA_TYPE]: PropTypes.oneOf(values(DATA_TYPE)).isRequired,
  // [PROPS.FILTER_TYPE]: PropTypes.oneOf(values(FILTER_TYPE)),
  // [PROPS.RELATED_FILTERS]: PropTypes.arrayOf(PropTypes.oneOf(values(FILTER_TYPE))),
  loading: PropTypes.bool,
  hideDownloadButtons: PropTypes.bool,
  showArticleReportCSVButton: PropTypes.bool,
  hidePdfButton: PropTypes.bool,
  showChangeTableViewButton: PropTypes.bool,
  headerFilters: PropTypes.element,
  localCurrencySwitches: PropTypes.object,
  handleLocalCurrencySwitches: PropTypes.func,
  // Actions
  applyFilter: PropTypes.func,
  emptyMessage: PropTypes.string
});

_defineProperty(TableView, "defaultProps", {
  loadData: true,
  loading: false,
  hideDownloadButtons: false,
  emptyMessage: "table/emptyData"
});